import { render, staticRenderFns } from "./addAsin.vue?vue&type=template&id=b83f2f80&scoped=true"
import script from "./addAsin.vue?vue&type=script&lang=js"
export * from "./addAsin.vue?vue&type=script&lang=js"
import style0 from "./addAsin.vue?vue&type=style&index=0&id=b83f2f80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83f2f80",
  null
  
)

export default component.exports